import React from 'react';
import './custom.scss';
import ReactDOM from 'react-dom';
import BrightspaceServices from './BrightspaceServices';
import { CookiesProvider } from "react-cookie";
import reportWebVitals from './reportWebVitals';

ReactDOM.render(
    <CookiesProvider>
<BrightspaceServices />
   </CookiesProvider>,
  document.getElementById('root')
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
